import Vue from 'vue'
import { mapState } from 'vuex'
import $ from 'jquery'

Vue.component('zoom-gallery', {
  props: {
    productTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      zoomExpanded: false,
      zoomPopup: false,
      previousFocus: null
    }
  },
  computed: {
    ...mapState('product', ['product']),
    images () {
      if (!this.product || !this.product.images) return []
      return this.product.images
    }
  },
  mounted () {
    this.zoomPopup = true
    this._onZoomOpen = (e) => this.showZoom(e.detail)
    this._onDocumentKeydown = (e) => {
      if (this.zoomExpanded && e.key === 'Escape') {
        e.preventDefault()
        this.closeZoom()
      }
    }
    document.addEventListener('zoom:open', this._onZoomOpen)
    document.addEventListener('keydown', this._onDocumentKeydown)
  },
  beforeDestroy () {
    document.removeEventListener('zoom:open', this._onZoomOpen)
    document.removeEventListener('keydown', this._onDocumentKeydown)
  },
  methods: {
    focusImage (index) {
      const images = this.$el ? this.$el.querySelectorAll('.img') : []
      const image = images[index]

      if (!image) return

      image.focus()
      image.scrollIntoView({ block: 'center' })
    },
    getImageIndex (target) {
      const image = target.closest('.img')
      if (!image || !this.$el) return -1

      return Array.prototype.indexOf.call(this.$el.querySelectorAll('.img'), image)
    },
    onImageClick (e) {
      const img = e.target.closest('img.img__el')
      if (img) {
        const wrapper = img.closest('.img') || img.closest('picture')
        if (wrapper) {
          wrapper.classList.toggle('zoomed')
        }
      }
    },
    onImageKeydown (e) {
      const index = this.getImageIndex(e.target)
      const lastIndex = this.images.length - 1

      if (e.key === 'Escape') {
        e.preventDefault()
        e.stopPropagation()
        this.closeZoom()
        return
      }

      if (index < 0) return

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        e.currentTarget.classList.toggle('zoomed')
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault()
        this.focusImage(Math.min(index + 1, lastIndex))
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault()
        this.focusImage(Math.max(index - 1, 0))
      } else if (e.key === 'Home') {
        e.preventDefault()
        this.focusImage(0)
      } else if (e.key === 'End') {
        e.preventDefault()
        this.focusImage(lastIndex)
      }
    },
    onGalleryKeydown (e) {
      if (e.key !== 'Escape') return

      e.preventDefault()
      this.closeZoom()
    },
    onGalleryFocusout (e) {
      if (!this.zoomExpanded || !this.$el) return

      const nextFocus = e.relatedTarget
      if (nextFocus && this.$el.contains(nextFocus)) return

      this.closeZoom(false)
    },
    closeZoom (restoreFocus = true) {
      this.zoomExpanded = false
      document.body.classList.remove('overflow-hidden')
      $('.zoom-images-gallery').scrollTop(0)

      if (restoreFocus && this.previousFocus && typeof this.previousFocus.focus === 'function') {
        this.previousFocus.focus()
      }
    },
    showZoom (refName) {
      this.previousFocus = document.activeElement
      this.zoomExpanded = true
      document.body.classList.add('overflow-hidden')

      this.$nextTick(() => {
        setTimeout(() => {
          if (refName === 'mobile') {
            const index = $('.product-gallery .slick-active').data('slick-index')
            const top = $('#div' + index).position().top
            $('.zoom-images-gallery').scrollTop(top)
          } else {
            const el = document.getElementById(refName)
            if (el) {
              const top = $(el).position().top
              $('.zoom-images-gallery').scrollTop(top)
            }
          }

          const focusIndex = refName === 'mobile'
            ? $('.product-gallery .slick-active').data('slick-index') || 0
            : parseInt(String(refName).replace('div', ''), 10) || 0

          this.focusImage(focusIndex)
        }, 100)

      })
    }
  },
  template: `
    <div class="zoom-images-gallery hide"
      :class="{ 'zoom-show': zoomExpanded }"
      v-if="zoomPopup"
      role="dialog"
      aria-modal="true"
      @click="onImageClick"
      @keydown="onGalleryKeydown"
      @focusout="onGalleryFocusout">
      <div class="zoom-header">
        <button class="zoom-gallery__close" @click.prevent="closeZoom">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.9999 1L1.2832 20.7166L20.9999 1Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M20.7167 20.7166L1 1L20.7167 20.7166Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <span v-for="(image, index) in images"
        :key="index"
        :ref="'div' + index"
        :id="'div' + index">
        <vue-image
          tabindex="0"
          role="button"
          aria-label="Product image zoom"
          @keydown.native="onImageKeydown"
          :src="image.src"
          :alt="image.alt || productTitle"
          fit="contain"
          pos="center"
          :transparent="false"
          :lazy="true"></vue-image>
      </span>
    </div>
  `
})
